import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { formatDate_MM_DD_YYYY, shouldHavePermission } from '../../../../../Assests/Utility';
import { AppConstant } from '../../../../../Assests/AppConstant'
import { sagaActions } from '../../../../../../sagas/sagaActions';
import WarehouseSearch from '../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearch';
import moment from 'moment-timezone';
import "react-datepicker/dist/react-datepicker.css";
import "../../../../../Components/DatePicker/DatePicker.css"
import { getRemoteConfigSelector } from '../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import DrilldownTableSS from '../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { getEclipseOpsPaymentLoadselector } from '../../../../../../redux/reducers/reducerSlices/EclipseOpsPaymentLoadReducer';
import "./EclipseOpsPaymentLoad.css"
import DatePickerSS from '../../../../DatePickerSS/DatePickerSS';
import Popup from '../../../../Common/Popup/Popup';
import PDFViewer from '../../../../Common/PdfViewer/PdfViewer';
import { CustomDynamicForm } from '../../../../Common/CustomForm/CustomDynamicForm';
import view from "../../../../../Assests/Images/view.png"
import email_appts_dark from "../../../../../Assests/Images/email_appts_dark.png"
import info from "../../../../../Assests/Images/info.png"
import { getUserSelector } from '../../../../../../redux/reducers/reducerSlices/UserReducer';
import { closeUpdatesSocketConnection, initializeUpdatesSocketConnection } from '../../../../../../Utils/updateSocket';
import TinyLoader from '../../../../Common/TinyLoader/TinyLoader';
import pay from "../../../../../Assests/Images/pay.png"
import { toast } from 'react-toastify';
import { showAlert } from "../../../../../Assests/Utility";
import ModalSS from '../../../../SmartSchedule/SchedulePro/Components/Common/ModalSS/ModalSS';
import FSPayPOHistory from './FSPayPOHistory';
import CustomButtonSS from '../../../../Common/CustomButton/CustomButtonSS';
import CustomDropDown from '../../../../Common/CustomDropDown/CustomDropDown';
import EclipseOpsPaymentFileUpload from './EclipseOpsPaymentFileUpload';
import DownloadSection from '../../DownloadSection/DownloadSection';
import { usePrevious } from '../../../../Common/CustomHooks/usePrevious';
import { getAuthReducer } from '../../../../../../redux/reducers/reducerSlices/AuthReducer';
import { getWarehouseDataReducer } from '../../../../../../redux/reducers/reducerSlices/GetWarehouseDataReducer';


const EclipseOpsPaymentLoad = (props) => {
    const { themeSelected = 'light-mode' } = props;
    const dispatch = useDispatch();
    const [searchStr, setSearchStr] = useState('');
    const divRef = useRef(null);
    const [currentTable, setCurrentTable] = useState(null);
    const [currentTableRef, setCurrentTableRef] = useState(null);
    const previousTable = usePrevious(currentTable);
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration
    const eclipseOpsReducer = useSelector(getEclipseOpsPaymentLoadselector)
    const { getEclipseOpsPaymentData, isLoading, initiateLoading, EclipseOpsPaymentList, LastEvaluatedKey, LastPage, eclipseServiceFee, btnLoading, manualPaymentMethodsList, deleteLoading, fileUploadLoading, removeFileLoading, downloadRequestLoading } = eclipseOpsReducer;
    const user = useSelector(getUserSelector);
    const auth = useSelector(getAuthReducer);
    const warehouseData = useSelector(getWarehouseDataReducer);
    const { userType, userAccountDetails, permissions } = user
    const [eclipseOpsPayLoadArr, setEclipseOpsPayLoadArr] = useState([]);
    const [isError, setIsError] = useState(false)
    const first = useRef(true);
    const firstPageLoad = useRef(true);
    const firstWarehouseRender = useRef(true);
    const firstSearchRender = useRef(true);
    const firstFilterRender = useRef(true);
    const [showStartDate, setShowStartDate] = useState(false)
    const [showEndDate, setShowEndDate] = useState(false)
    const [webPayPermission, setwebPayPermission] = useState(false)
    const [deletePermission, setDeletePermission] = useState(false)
    const [manualPaymentPermission, setmanualPaymentPermission] = useState(false)
    const [receiptPermission, setreceiptPermission] = useState(false)
    const [emailPermission, setemailPermission] = useState(false)
    const [uploadPermission, setUploadPermission] = useState(false)
    const [smsPermission, setsmsPermission] = useState(false)
    const [warehouseFilterPermission, setWarehouseFilterPermission] = useState(false)
    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const dStart = new Date()
        dStart.setHours(0, 0, 0, 0);
        return dStart
    })
    const [selectedEndDate, setSelectedEndDate] = useState(() => {
        const dEnd = new Date()
        dEnd.setHours(23, 59, 59, 0);
        return dEnd
    })
    const [showModal, setShowModal] = useState(false);
    const [selectedObj, setSelectedObj] = useState(null);
    const [editData, setEditData] = useState({});
    const [editPaymentData, setEditPaymentData] = useState({});
    const [resetFormData, setResetFormData] = useState(0);
    const [particularFieldValue, setParticularFieldValue] = useState("");
    const [showShareReceiptModal, setShowShareReceiptModal] = useState(false)
    const [showDownloadModal, setShowDownloadModal] = useState(false)
    const [downloadStartDate, setDownloadStartDate] = useState(selectedStartDate)
    const [downloadEndDate, setDownloadEndDate] = useState(selectedEndDate)
    const [downloadEmail, setDownloadEmail] = useState('')
    const [showDownloadStartDate, setShowDownloadStartDate] = useState(false)
    const [showDownloadEndDate, setShowDownloadEndDate] = useState(false)
    const [downloadWarehouse, setDownloadWarehouse] = useState(null)
    const [fileUploadModal, setFileUploadModal] = useState(false)
    const [showDeletePoModal, setShowDeletePoModal] = useState(false)
    const [showSmsDueModal, setShowSmsDueModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [withAttachment, setWithAttachment] = useState(false);
    const [maxEndDate, setMaxEndDate] = useState(new Date())
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse } = userPermission;
    const [dropdownWarehouse, setDropdownWarehouse] = useState(null);
    const [userWarehouseList, setUserWarehouseList] = useState([]);
    const [socketRef, setSocketRef] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [currentLimit, setCurrentLimit] = useState(25);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [currentIndex, SetCurrentIndex] = useState("NA")
    const [paymentMethod, setPaymentMethod] = useState(null)
    const [fSPayPOHistoryModal, setFSPayPOHistoryModal] = useState(null)
    const [poData, setPoData] = useState(null)
    const searchRef = useRef(searchStr)
    const [currentFilterSelected, setCurrentFilterSelected] = useState({
        name: 'All',
        value: "ALL"
    },);

    const paymentOptions = [
        {
            id: "1",
            name: "INSTA MONEY",
            value: "INSTA-MONEY-MANUAL"
        },
        {
            id: "2",
            name: "US BANK",
            value: "US-BANK-MANUAL"
        },
        {
            id: "3",
            name: "Relay",
            value: "RELAY_MANUAL"
        },
        {
            id: "4",
            name: "EFS",
            value: "EFS_MANUAL"
        },
        {
            id: "5",
            name: "T-Chek",
            value: "T_CHEK_MANUAL"
        },
        {
            id: "6",
            name: "Credit Card",
            value: "CREDIT_CARD_MANUAL"
        },
        {
            id: "7",
            name: "Comdata",
            value: "COMDATA_MANUAL"
        },
    ]

    let extraDataToShow = {
        reportName: "FSPay Payments Report",
        filter: {
            dateRange: {
                StartDate: { name: "Start Date", value: moment(selectedStartDate).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat), show: true },
                EndDate: { name: "End Date", value: moment(selectedEndDate).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat), show: true },
            },
            currentFilterSelected: {
                name: 'Filter',
                value: currentFilterSelected?.name,
                show: true
            }
        }
    }

    useEffect(() => {
        const container = divRef.current;
        const tables = container.querySelectorAll('table');
        if (tables && tables.length && _.isEqual(currentTable, previousTable)) {
            setCurrentTableRef(container);
            setCurrentTable(tables);
        }
    }, [eclipseOpsPayLoadArr])
    
    /**
        * Used to perform neccesary action on load
        */
    useEffect(() => {
        dispatch({ type: sagaActions.INITIATE_FSPAY_LOADING, payload: false })
        dispatch({ type: sagaActions.CLEAR_ECLIPSE_OPS_PAYMENT_LIST })
        dispatch({ type: sagaActions.CLEAR_ECLIPSE_SERVICE_FEE })
        fetchData()
        let tout = setTimeout(() => {
            dispatch({ type: sagaActions.GET_MANUAL_PAYMENT_METHODS_LIST })
        }, 0)
        // Always load warehouse list so the download popup dropdown is populated
        dispatch({ type: sagaActions.GET_WAREHOUSE_LIST, payload: { "user_type": "SUPERADMIN", "cu_id": null, "company_id": "7" } });
        return () => {
            dispatch({ type: sagaActions.CLEAR_ECLIPSE_OPS_PAYMENT_LIST })
            clearTimeout(tout)
        }
    }, [])

    useEffect(() => {
        if (warehouseData?.data) {
            setUserWarehouseList(warehouseData.data);
        }
    }, [warehouseData.data]);

    useEffect(() => {
        if (warehouseFilterPermission) {
            dispatch({ type: sagaActions.GET_WAREHOUSE_LIST, payload: { "user_type": "SUPERADMIN", "cu_id": null, "company_id": "7" } });
        }
    }, [warehouseFilterPermission]);

    useEffect(() => {
        if (!deleteLoading && currentIndex !== "NA") {
            SetCurrentIndex("NA")
            fetchData()
        }
    }, [deleteLoading])

    useEffect(() => {
        if (!fileUploadLoading && currentIndex !== "NA") {
            SetCurrentIndex("NA")
            closeFileUpload()
            fetchData()
        }
    }, [fileUploadLoading])

    useEffect(() => {
        if (!removeFileLoading && currentIndex !== "NA") {
            SetCurrentIndex("NA")
            // closeFileUpload()
            fetchData()
        }
    }, [removeFileLoading])


    useEffect(() => {
        if (EclipseOpsPaymentList && EclipseOpsPaymentList.length && selectedObj) {
            const findOne = EclipseOpsPaymentList.filter((el) => el.RecID === selectedObj.RecID)
            if (findOne && findOne.length) {
                setSelectedObj((prev) => {
                    return { ...prev, fileUrl: findOne[0].fileUrl };
                })
            } else {
                closeFileUpload()
            }
        }
    }, [EclipseOpsPaymentList])



    useEffect(() => {
        if (permissions) {
            setwebPayPermission(shouldHavePermission(permissions, "975"))
            setreceiptPermission(shouldHavePermission(permissions, "976"))
            setemailPermission(shouldHavePermission(permissions, "977"))
            setmanualPaymentPermission(shouldHavePermission(permissions, "978"))
            setDeletePermission(shouldHavePermission(permissions, "988"))
            setUploadPermission(shouldHavePermission(permissions, "991"))
            setsmsPermission(shouldHavePermission(permissions, "992"))
            setWarehouseFilterPermission(shouldHavePermission(permissions, "993"))
        }
    }, [permissions])

    /**
 * This function used to fetch eclipse ops details by connecting with API
 */
    const fetchData = (pageNo = 1, limit = 25, search = null, statusFilter = null) => {
        if ((!LastPage || pageNo === 1) && !isLoading) {
            setTimeout(() => {
                const hasSearch = search && search.trim().length > 0;
                if (selectedEndDate) {
                    selectedEndDate.setHours(23, 59, 59, 0);
                }
                const params = {
                    "startDate": selectedStartDate ? moment(selectedStartDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss) : null,
                    "endDate": selectedEndDate ? moment(selectedEndDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss) : null,
                    "currentPage": pageNo,
                    "itemsPerPage": limit,
                    "filterParam": dropdownWarehouse?.WarehouseName || selectedWarehouse?.warehouseName || null,
                    "LastEvaluatedKey": pageNo === 1 ? null : LastEvaluatedKey,
                    "CRUDTYPE": "S",
                    "searchParam": hasSearch ? search.trim() : null,
                    "status": statusFilter && statusFilter !== 'ALL' ? statusFilter : null,
                }
                dispatch({ type: sagaActions.GET_ECLIPSE_OPS_PAYMENT_LOAD_DETAILS, payload: params });
            }, 0)
        }
    }

    const deleteEclipseOpsPayloadLoadByRecID = (recID) => {
        if (recID) {
            SetCurrentIndex(recID)
            setTimeout(() => {

                const params = {
                    "recID": recID,
                    "CRUDTYPE": "D"
                }

                dispatch({ type: sagaActions.GET_ECLIPSE_OPS_PAYMENT_LOAD_DETAILS, payload: params });
            }, 0)
        }
    }
    useEffect(() => {
        if (first.current) {
            first.current = false;
            return;
        }
        if (!isError && selectedStartDate && selectedEndDate) {
            setTimeout(() => {
                setCurrentPage(1);
                const statusFilter = !searchStr && currentFilterSelected?.value !== 'ALL' ? currentFilterSelected?.value : null;
                fetchData(1, currentLimit, searchStr || null, statusFilter);
            }, 0);
        }
    }, [selectedStartDate, selectedEndDate]);

    /**
     * Handles infinite scroll — increments page when user reaches bottom of list.
     * Uses Math.ceil to handle subpixel / floating-point scroll values.
     */
    const handelInfiniteScroll = (e) => {
        try {
            const { scrollHeight, scrollTop, clientHeight } = e.target;
            const distanceFromBottom = Math.ceil(scrollHeight - scrollTop) - clientHeight;
            if (distanceFromBottom <= 2 && !isLoading && !LastPage) {
                setCurrentPage((prev) => prev + 1);
            }
        } catch (error) {
        }
    };

    /**
     * Infinite scroll page increment — fetch next batch when currentPage increments via scroll
     */
    useEffect(() => {
        if (firstPageLoad.current) {
            firstPageLoad.current = false;
            return;
        }
        if (currentPage > 1) {
            const statusFilter = !searchStr && currentFilterSelected?.value !== 'ALL' ? currentFilterSelected?.value : null;
            fetchData(currentPage, currentLimit, searchStr || null, statusFilter);
        }
    }, [currentPage]);


    /**
     * Tabular array of headers to display
     */
    const titleDD = [
        { id: 'LocID', name: 'Site' },
        { id: 'poNumber', name: 'PO' },
        { id: 'Carrier', name: 'Carrier' },
        // { id: 'driverName', name: 'Driver Name' },
        { id: 'driverNumber', name: 'Driver No.' },
        { id: 'Bill Amount', name: '$Bill' },
        { id: 'Addl. Charges', name: '$Addl' },
        { id: 'amount', name: '$Fee' },
        { id: 'amount', name: '$Invoice' },
        { id: 'amount', name: '$Paid' },
        { id: 'paymentStatus', name: 'Status' },
        { id: 'authNumber', name: 'Auth No.' },
        { id: 'transactionType', name: 'Mode' },
        { id: 'transactionStatus', name: 'Comments' },
        { id: 'CreatedOn', name: 'Created' },
        { id: 'UpdatedOn', name: 'Updated' },
        { id: 'ProcessedOn', name: 'Processed On' },
        { id: 'action', name: 'Action' },
    ]

    useEffect(() => {
        if (!initiateLoading) {
            closeManualPayment()
        }
    }, [initiateLoading])

    // useEffect(()=>{
    //     if (!btnLoading && currentIndex!=='NA') {
    //         SetCurrentIndex("NA")
    //     }
    // },[btnLoading])

    useEffect(() => {
        if (selectedObj && selectedObj.LocID && paymentMethod) {
            getEclipseServiceFee()
        }
    }, [paymentMethod])

    useEffect(() => {
        if (eclipseServiceFee && selectedObj) {
            // manualPaymentHandler(selectedObj)
            setParticularFieldValue({ ...particularFieldValue, amount: `$${getManualAmount(selectedObj, true, eclipseServiceFee)}`, serviceFee: `$${calculateServiceFee(selectedObj, eclipseServiceFee)}`, billAmount: `$${parseFloat(getTheNumberWithoutSpaces(selectedObj.CCCollect)).toFixed(2)}` })
        }
    }, [eclipseServiceFee])

    useEffect(() => {
        if (loading && !initiateLoading) {
            setLoading(initiateLoading)
            setShowShareReceiptModal(false)
            setWithAttachment(false)
        }
    }, [initiateLoading])

    useEffect(() => {
        if (!downloadRequestLoading && showDownloadModal) {
            setShowDownloadModal(false)
        }
    }, [downloadRequestLoading])


    /**
     * checking the eclipse ops list 
     */
    // useEffect(() => {
    //     if (EclipseOpsPaymentList) {
    //         const uniqueList = _.uniqBy(EclipseOpsPaymentList,"RecID")
    //         setEclipseOpsPayLoadArr(uniqueList)
    //     } else {
    //         setEclipseOpsPayLoadArr([])
    //     }

    // }, [EclipseOpsPaymentList])


    /**
     * validates and gets the details
     */
    /**
     * Backend search debounce — triggers fetch when PO number search changes
     */
    useEffect(() => {
        if (firstSearchRender.current) {
            firstSearchRender.current = false;
            return;
        }
        // When search is active, reset the status filter to "All" so it reflects
        // the correct state when the dropdown becomes visible again after clearing search.
        if (searchStr && currentFilterSelected?.value !== 'ALL') {
            setCurrentFilterSelected({ name: 'All', value: "ALL" });
        }
        const tout = setTimeout(() => {
            setCurrentPage(1);
            fetchData(1, currentLimit, searchStr || null);
        }, 1000);
        return () => clearTimeout(tout);
    }, [searchStr]);

    /**
     * Refetch when warehouse dropdown selection changes
     */
    useEffect(() => {
        if (firstWarehouseRender.current) {
            firstWarehouseRender.current = false;
            return;
        }
        setCurrentPage(1);
        const statusFilter = !searchStr && currentFilterSelected?.value !== 'ALL' ? currentFilterSelected?.value : null;
        fetchData(1, currentLimit, searchStr || null, statusFilter);
    }, [dropdownWarehouse]);

    /**
     * Calls the API when status filter changes and no search is active.
     * Also keeps a frontend pass on the returned list for real-time socket updates.
     */
    useEffect(() => {
        if (firstFilterRender.current) {
            firstFilterRender.current = false;
            return;
        }
        if (!searchStr) {
            setCurrentPage(1);
            const statusFilter = currentFilterSelected?.value !== 'ALL' ? currentFilterSelected?.value : null;
            fetchData(1, currentLimit, null, statusFilter);
        }
    }, [currentFilterSelected]);

    useEffect(() => {
        // Frontend filter applied to API-returned data as a secondary pass (handles real-time socket updates)
        const tout = setTimeout(() => {
            let filters = {};
            if (currentFilterSelected && currentFilterSelected.value && currentFilterSelected.value === "PO_DELETED") {
                filters.transactionStatus = currentFilterSelected.value;
            } else {
                filters.RelayStatus = currentFilterSelected?.value || "ALL";
            }

            const res = searchAndFilter(EclipseOpsPaymentList, "", filters, []);
            const uniqueList = _.uniqBy(res, "RecID");
            setEclipseOpsPayLoadArr(uniqueList);
        }, 100);

        return () => { clearTimeout(tout); };
    }, [currentFilterSelected, EclipseOpsPaymentList]);


    useEffect(() => {
        validateURLandFetchPayments()
        return () => {
            if (socketRef) {
                const socketId = selectedWarehouse?.warehouseName || (userType !== 'USER' ? "FSADMIN" : null)
                closeUpdatesSocketConnection(socketRef, socketId)
            }
        }
    }, [])


    useEffect(() => {
        searchRef.current = searchStr
    }, [searchStr])

    /**
      * Method is used to handle truck update and fetch latest truck data
      */
    const onUpdateSocketReceived = (message, date) => {
        let parsedMessage = JSON.parse(message)
        if (typeof parsedMessage === 'string') {
            parsedMessage = JSON.parse(parsedMessage)
        }
        if (!_.isEmpty(parsedMessage)) {
            const { type } = parsedMessage;
            switch (type) {
                case 'FS_PAYMENT':
                    if (selectedStartDate && selectedEndDate) {
                        let isAlreadyExist = _.some(EclipseOpsPaymentList, item =>
                            item.RecID === parsedMessage.RecID && item.RelayStatus === parsedMessage.RelayStatus && item.LocID === parsedMessage.LocID)
                        // When a warehouse is selected in the dropdown, only show updates for that warehouse.
                        // Otherwise, follow the default behavior (show all for admins, filter by assigned for users).
                        const warehouseMatches = !dropdownWarehouse || dropdownWarehouse.WarehouseName === parsedMessage.LocID;
                        const userWarehousePermission = !selectedWarehouse?.warehouseName || selectedWarehouse?.warehouseName === parsedMessage.LocID;

                        if (warehouseMatches && userWarehousePermission) {
                            let startDate = moment(selectedStartDate)
                            let endDate = moment(selectedEndDate)
                            const isInRange = moment(parsedMessage.CreatedOn).isBetween(startDate, endDate, undefined, "[]")
                            if (!isAlreadyExist && isInRange) {
                                dispatch({ type: sagaActions.UPDATE_REAL_TIME_FS_PAYMENT_LIST, payload: parsedMessage })
                            }
                        }

                    }
                    break;
                default:
                    break;
            }
        }


    }


    /**
     * Method is used to captcure socket error and re initate the connection 
     * @param {*} error 
     */
    const onUpdateSocketError = (error) => {
        validateURLandFetchPayments()
    }

    /**
     * Method is used to capture socket close
     * @param {*} data 
     */
    const onUpdateSocketClose = (data) => {

        //check if user is on same page and if it NORMAL closure or not or IDLE session closure
        //initiatesocket connection
        // refetch appointment data
        if (data.code !== 1000) {
            validateURLandFetchPayments()
        }
    }

    const validateURLandFetchPayments = () => {

        if (window.location.pathname === '/fspaypayment') {
            const socketId = selectedWarehouse?.warehouseName || (userType !== 'USER' ? "FSADMIN" : null)
            let socketRefTemp = initializeUpdatesSocketConnection(socketId, AppConstant.commonStrings.truckUpdateSocketUrl, onUpdateSocketReceived, onUpdateSocketError, onUpdateSocketClose, onUpdateSocketOpen, null)
            setSocketRef(socketRefTemp)
        }
    }

    const onUpdateSocketOpen = () => {
        // console.log('Socket connection established.');
    };

    /**
     * method is used to check is paid
     * @param {*} status 
     */
    const isPaid = (status) => {
        if (status && status.toUpperCase() === "SUCCESS") {
            return true
        }
        return false
    }


    /**
     * Function to render status
     * @param {*} status 
     * @returns JSX
     */
    const getPaymentStatus = (status, data) => {
        // if (data.transactionStatus === 'PO_DELETED') {
        //     return <span id='required'>PO Deleted</span>
        // }
        if (status?.toUpperCase() === "CREATED" || !status) {
            return <span className='color-black'>{"Pending"}</span>
        } else if (status.toUpperCase() === "SUCCESS") {
            return <span className='textGreen'>{status}</span>
        } else {
            return <span className='textRed'>{status}</span>
        }
    }

    /**
     * Function to render Receipt popup
     * @returns 
     */
    const showReceiptPopup = () => {
        const popupObj = {
            id: 'showReceiptPopup1',
            modalLabel: 'showReceiptPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'xl',
            title: "Receipt",
            bodyText: viewReceipt(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeCurrentpopup} themeSelected={themeSelected} showModal={showModal} />
    }

    /**
     * Function to close receipt popup
     */
    const closeCurrentpopup = () => {
        setShowModal(false)
    }

    /**
     * Function to render receipt
     * @returns 
     */
    const viewReceipt = () => {
        return (
            <>
                {selectedObj && selectedObj.receiptUrl ? <PDFViewer pdfUrl={selectedObj.receiptUrl} width={"100%"} height={"500px"} /> : <span className='d-flex justify-content-center align-items-center f-18 fw-bold' style={{ height: "500px", width: "100%" }}>No Receipt Found!</span>}
            </>
        )
    }

    const formFieldList = [
        {
            name: "email",
            type: "email",
            size: "col-sm-12",
            position: 1,
            title: AppConstant.login.email,
            formValidation: {
                required: true,
                validateEmail: true,
            },
        }]

    /**
 * Function to render share Receipt popup
 * @returns 
 */
    const showReceiptSharePopup = () => {
        const popupObj = {
            id: 'showReceiptSharePopup1',
            modalLabel: 'showReceiptSharePopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: "Share Receipt",
            bodyText: shareReceipt(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeShareReceiptpopup} themeSelected={themeSelected} showModal={showShareReceiptModal} />
    }

    /**
     * Function to close share receipt popup
     */
    const closeShareReceiptpopup = () => {
        setShowShareReceiptModal(false)
        setWithAttachment(false)
    }

    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
    };

    const submitbtnData = {
        show: true,
        text: AppConstant.commonStrings.share,
    };


    const cancelbtndataPayment = {
        show: false,
        text: AppConstant.comments.cancelCommentButtonTitle,
    };

    const submitbtnDataPayment = {
        show: true,
        text: AppConstant.eclipseOpsPaymentLoad.paymentComplete
    };


    const getEclipseServiceFee = () => {
        const getMode = (type) => {
            if (type === "RELAY" || type === "COMDATA" || type === "EFS" || type === "TCHEK" || type === "CHECK") {
                return "CHECK"
            } else if (type === "CREDITCARD") {
                return "CCARD"
            }

        }
        const initiateGetServiceFee = (type) => {
            const body = {
                "locId": selectedObj.LocID,
                "feeType": getMode(type)
            }
            dispatch({ type: sagaActions.GET_ECLIPSE_SERVICE_FEE, payload: body })
        }
        switch (paymentMethod) {
            case "RELAY_MANUAL":
                return initiateGetServiceFee("RELAY")
            case "COMDATA_MANUAL":
                return initiateGetServiceFee("COMDATA")
            case "EFS_MANUAL":
                return initiateGetServiceFee("EFS")
            case "T_CHEK_MANUAL":
                return initiateGetServiceFee("TCHEK")
            case "CREDIT_CARD_MANUAL":
                return initiateGetServiceFee("CREDITCARD")
            case "INSTA-MONEY-MANUAL":
                return initiateGetServiceFee("CHECK")
            case "US-BANK-MANUAL":
                return initiateGetServiceFee("CHECK")
        }

    }


    const getPaymentOptions = () => {

        return (
            manualPaymentMethodsList &&
            manualPaymentMethodsList?.map((data, index) => {
                return (
                    <option key={data.ID} value={data.ID}>
                        {data.PaymentType}
                    </option>
                );
            })
        );
    }

    const formFieldListPayment = [
        {
            name: "po",
            type: "text",
            size: "col-sm-12",
            position: 1,
            title: "PO",
            formValidation: {
                required: true,
            },
            isEditDisable: true,
        },
        {
            name: "paymentType",
            type: "select",
            size: "col-sm-12",
            position: 1,
            title: "Payment Type",
            formValidation: {
                required: true,
            },
            getSelectData: getPaymentOptions,
        },
        {
            name: "billAmount",
            type: "text",
            size: "col-sm-12",
            position: 2,
            title: "Bill Amount",
            formValidation: {
                required: true,
            },
            hideElement: {
                isHidden: paymentMethod && eclipseServiceFee ? true : false
            },
            isEditDisable: true,
            loading: btnLoading
        },
        {
            name: "serviceFee",
            type: "text",
            size: "col-sm-12",
            position: 2,
            title: "Service Fee",
            formValidation: {
                required: true,
            },
            hideElement: {
                isHidden: paymentMethod && eclipseServiceFee ? true : false
            },
            isEditDisable: true,
            loading: false
        },
        {
            name: "amount",
            type: "text",
            size: "col-sm-12",
            position: 2,
            title: "Total Amount",
            formValidation: {
                required: true,
            },
            hideElement: {
                isHidden: paymentMethod && eclipseServiceFee ? true : false
            },
            isEditDisable: true,
            loading: false
        },
        {
            name: "check",
            type: "text",
            size: "col-sm-12",
            position: 2,
            title: "Check/Auth No.",
            formValidation: {
                required: true,
            },
        }]

    const formatFSPhoneNumber = (phoneNumber) => `+1${phoneNumber.split("-").join("")}`

    const getSummitedFormDataPayment = (data) => {
        const transactionData = {
            recID: selectedObj.RecID,
            transactionType: data.paymentType,
            paymentCode: data.check,
            driverLastName: userAccountDetails?.LastName,
            driverFirstName: userAccountDetails?.FirstName,
            carrierName: "",
            fullAmount: getManualAmount(selectedObj, true, eclipseServiceFee),
            driverPhoneNumber: formatFSPhoneNumber(selectedObj?.Field36),
            user_number: formatFSPhoneNumber(selectedObj?.Field36),
            transactionDateTime: moment(),
            timeZone: "UTC+6",
            unitNum: null,
            tripNum: null,
            relaySiteId: selectedObj.LocID,
            tabletype: "eclipseOps",
            serviceFee: calculateServiceFee(selectedObj, eclipseServiceFee),
            paymentType: "Full Payment",
        }
        dispatch({ type: sagaActions.FS_PAY_MANUAL_PAYMENT, payload: transactionData })
    }

    const getFormFieldDataPayment = (data, name) => {
        if (name === 'paymentType') {
            setPaymentMethod(data)
        }
    };

    const ShowPaymentOptions = () => {
        return (
            <>
                <CustomDynamicForm
                    formFieldList={formFieldListPayment}
                    sort={true}
                    cancelBtn={null}
                    submitbtn={submitbtnDataPayment}
                    themeSelected={themeSelected}
                    getFormFieldData={getFormFieldDataPayment}
                    getSummitedFormData={getSummitedFormDataPayment}
                    editFormData={editPaymentData}
                    loading={initiateLoading}
                    resetFormData={resetFormData}
                    setParticularFieldValue={particularFieldValue}
                    customDisableSave={btnLoading}
                />
            </>
        )
    }

    const closeManualPayment = () => {
        setShowPaymentModal(false);
        setSelectedObj(null)
        setPaymentMethod(null)
        // setEditPaymentData({})
        // setParticularFieldValue({})
        dispatch({ type: sagaActions.CLEAR_ECLIPSE_SERVICE_FEE })
    }

    const showPaymentPopup = () => {
        const popupObj = {
            id: 'showPaymentPopup1',
            modalLabel: 'showPaymentPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: "Payment",
            bodyText: ShowPaymentOptions(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.eclipseOpsPaymentLoad.paymentComplete
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={() => { closeManualPayment() }} themeSelected={themeSelected} showModal={showPaymentModal} />
    }

    const getSummittedDownloadFormData = () => {
        if (!downloadEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(downloadEmail)) {
            showAlert(toast.TYPE.ERROR, 'Please enter a valid email address.', 'light')
            return
        }
        if (!downloadStartDate) {
            showAlert(toast.TYPE.ERROR, 'Please select a start date.', 'light')
            return
        }
        if (!downloadEndDate) {
            showAlert(toast.TYPE.ERROR, 'Please select an end date.', 'light')
            return
        }
        const params = {
            "startDate": moment(downloadStartDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
            "endDate": moment(downloadEndDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
            "email": downloadEmail,
            "filterParam": downloadWarehouse ? downloadWarehouse.WarehouseName : null,
        }
        dispatch({ type: sagaActions.ECLIPSE_OPS_DOWNLOAD_REQUEST, payload: params })
    }

    const closeDownloadPopup = () => {
        setShowDownloadModal(false)
        setShowDownloadStartDate(false)
        setShowDownloadEndDate(false)
    }

    const downloadRequestBody = () => {
        const warehouseListWithAll = [{ WarehouseName: 'All Warehouses', ID: 'all' }, ...(userWarehouseList || [])]
        // Max end date = start date + 1 month (capped at today)
        const downloadMaxEndDate = downloadStartDate ? (() => {
            const maxDate = new Date(downloadStartDate);
            maxDate.setMonth(maxDate.getMonth() + 3);
            maxDate.setDate(maxDate.getDate() - 1);
            return maxDate > new Date() ? new Date() : maxDate;
        })() : new Date();

        return (
            <div className='d-flex flex-column gap-3 p-2'>
                {/* Start Date and End Date side by side */}
                <div className='d-flex gap-2'>
                    {/* Start Date */}
                    <div className='d-flex flex-column align-items-start pos-rel' style={{ flex: 1 }}>
                        <label className='boldText m-0 f-14 mb-1'>
                            <i className="fa-regular fa-calendar"></i> Start Date
                        </label>
                        <button
                            className='datePickerBtn w-100'
                            onClick={() => { setShowDownloadStartDate(!showDownloadStartDate); setShowDownloadEndDate(false); }}
                        >
                            <span className="btn-title">{downloadStartDate ? formatDate_MM_DD_YYYY(downloadStartDate) : 'Start Date'}</span>
                            <i className="fa-regular fa-calendar" style={{ marginInline: "9px" }}></i>
                        </button>
                        {showDownloadStartDate && (
                            <div className="appt-summary-ss-datePicker">
                                <DatePickerSS
                                    maxDate={new Date()}
                                    setSelectedDate={(date) => {
                                        setDownloadStartDate(date)
                                        setDownloadEndDate(null)
                                        setShowDownloadStartDate(false)
                                    }}
                                    selectedDate={downloadStartDate}
                                    closeCalendar={() => setShowDownloadStartDate(false)}
                                />
                            </div>
                        )}
                    </div>

                    {/* End Date */}
                    <div className='d-flex flex-column align-items-start pos-rel' style={{ flex: 1 }}>
                        <label className='boldText m-0 f-14 mb-1'>
                            <i className="fa-regular fa-calendar"></i> End Date
                        </label>
                        <button
                            className='datePickerBtn w-100'
                            onClick={() => { setShowDownloadEndDate(!showDownloadEndDate); setShowDownloadStartDate(false); }}
                        >
                            <span className="btn-title">{downloadEndDate ? formatDate_MM_DD_YYYY(downloadEndDate) : 'End Date'}</span>
                            <i className="fa-regular fa-calendar" style={{ marginInline: "9px" }}></i>
                        </button>
                        {showDownloadEndDate && (
                            <div className="appt-summary-ss-datePicker">
                                <DatePickerSS
                                    minDate={downloadStartDate ? new Date(downloadStartDate) : undefined}
                                    maxDate={downloadMaxEndDate}
                                    setSelectedDate={(date) => {
                                        setDownloadEndDate(date)
                                        setShowDownloadEndDate(false)
                                    }}
                                    selectedDate={downloadEndDate}
                                    closeCalendar={() => setShowDownloadEndDate(false)}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* Warehouse */}
                <div className='d-flex flex-column align-items-start'>
                    <label className='boldText m-0 f-14 mb-1'>Warehouse</label>
                    <select
                        className='form-select'
                        value={downloadWarehouse ? downloadWarehouse.ID : 'all'}
                        disabled={!!dropdownWarehouse || !!selectedWarehouse?.warehouseName}
                        onChange={(e) => {
                            const selected = warehouseListWithAll.find(w => String(w.ID) === e.target.value)
                            setDownloadWarehouse(selected?.ID === 'all' ? null : selected)
                        }}
                    >
                        {warehouseListWithAll.map(w => (
                            <option key={w.ID} value={w.ID}>{w.WarehouseName}</option>
                        ))}
                    </select>
                </div>

                {/* Email */}
                <div className='d-flex flex-column align-items-start'>
                    <label className='boldText m-0 f-14 mb-1'>Email</label>
                    <input
                        type='email'
                        className='form-control'
                        value={downloadEmail}
                        onChange={(e) => setDownloadEmail(e.target.value)}
                        placeholder='Enter email address'
                    />
                </div>

                {/* Buttons */}
                <div className='d-flex justify-content-end gap-2 mt-1'>
                    <button className='btn btn-secondary' onClick={closeDownloadPopup} disabled={downloadRequestLoading}>
                        {AppConstant.comments.cancelCommentButtonTitle}
                    </button>
                    <button className='btn' style={{ backgroundColor: 'var(--table-selection-text-light)', color: '#fff', borderColor: 'var(--table-selection-text-light)' }} onClick={getSummittedDownloadFormData} disabled={downloadRequestLoading}>
                        {downloadRequestLoading ? <span className='spinner-border spinner-border-sm me-1' role='status' aria-hidden='true'></span> : null}
                        Send
                    </button>
                </div>
            </div>
        )
    }

    const showDownloadRequestPopup = () => {
        const popupObj = {
            id: 'showDownloadRequestPopup1',
            modalLabel: 'showDownloadRequestPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: "Download Report",
            bodyText: downloadRequestBody(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: { show: false, text: '' },
                btn2: { show: false, text: '' }
            },
        }
        return <Popup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeDownloadPopup} themeSelected={themeSelected} showModal={showDownloadModal} />
    }

    const getSummitedFormData = (data) => {
        setLoading(true)
        let apiParams = { ...data }
        apiParams.id = selectedObj.RecID
        apiParams.withAttachment = withAttachment
        dispatch({ type: sagaActions.SHARE_RECEIPT_FOR_ECLIPSE_OPS_PAYMENT_LOAD, payload: apiParams })
    };

    /**
     * Function to render share receipt form
     * @returns 
     */
    const shareReceipt = () => {
        const shareFormFieldList = [
            ...formFieldList,
            {
                name: 'withAttachment',
                type: 'checkbox',
                size: 'col-sm-12',
                position: 2,
                title: 'Add Attachments',
                checked: withAttachment,
                onChange: (e) => setWithAttachment(e.target.checked),
                formValidation: {},
            }
        ];

        return (
            <CustomDynamicForm
                formFieldList={shareFormFieldList}
                sort={true}
                cancelBtn={cancelbtndata}
                submitbtn={submitbtnData}
                themeSelected={themeSelected}
                getFormFieldData={(data, name) => {
                    if (name === 'withAttachment') {
                        setWithAttachment(data);
                    }
                }}
                getSummitedFormData={getSummitedFormData}
                editFormData={editData}
                loading={loading}
                resetFormData={resetFormData}
                setParticularFieldValue={particularFieldValue}
            />
        );
    }

    const getMode = (data) => {
        if (data?.isManualTransaction) {
            return `${data?.transactionType}${data?.driverFirstName && "/" + data?.driverFirstName}`
        }
        return data?.transactionType
    }
    const mapTransactionStatus = (data) => {
        const { transactionStatus } = data
        const phoneNumberUpdate = `Old Number: ${data.oldPhoneNumber}`
        switch (transactionStatus) {
            case 'PO_DELETED':
                return (
                    <span id='required'>PO Deleted</span>
                )

            case 'CCCOLLECT_UPDATED':
                return 'Amount Updated'
            case 'RESTACK_UPDATED':
                return 'Amount Updated'
            case 'PONUMBER_UPDATED':
                return 'PO Number Updated'
            case 'PHONE_NUMBER_UPDATED':
                return (
                    <span title={phoneNumberUpdate} id='required'>Phone Number Updated</span>
                )
            case 'PAYMENT_METHOD_UPDATED':
                return (
                    <span id='required'>Payment Method Updated to {data.Field31}</span>
                )

            default:
                return '-'
        }
    }

    const fetchFSPayPOHistoryDetails = (data) => {

        setPoData(data)
        setFSPayPOHistoryModal(true)
    }

    /**
     * This function format the data
     * @param {*} data 
     * @returns 
     */
    const formatListDataDrillDown = (data) => {

        return data.map((el, index) => {
            const invoiceAmt = getAmount(el);
            const paidAmt = getPaidAmount(el);
            const isPaymentMismatch = el.RelayStatus?.toUpperCase() === 'SUCCESS' && Math.abs(invoiceAmt - paidAmt) < 0.011;

            return {
                0: el.LocID,
                1: <span style={{ textDecoration: 'underline', color: 'blue' }} onClick={() => fetchFSPayPOHistoryDetails(el)}>{el.PONumber}</span>,
                2: el.Carrier,
                // 3: el.Field35!='NA' && el.Field35? el.Field35 : '-',
                3: formatPhoneNumber(el.Field36) || '-',
                4: `$${parseFloat(getTheNumberWithoutSpaces(el?.CCCollect)).toFixed(2)}` || '$0',
                5: `$${parseFloat(getTheNumberWithoutSpaces(el?.ReStack)).toFixed(2)}` || '$0',
                6: `$${el.serviceFee ? parseFloat(el.serviceFee).toFixed(2) : 0}`,
                7: isPaymentMismatch
                    ? <span style={{ color: 'red', fontWeight: 'bold' }}>{invoiceAmt || '-'}</span>
                    : (invoiceAmt || '-'),
                8: isPaymentMismatch
                    ? <span style={{ color: 'red', fontWeight: 'bold' }}>{paidAmt || '-'}</span>
                    : (paidAmt || '-'),
                9: getPaymentStatus(el.RelayStatus, el),
                10: el.RelayCheckoutNumber || '-',
                11: getMode(el) || "-",
                12: isPaymentMismatch
                    ? <span style={{ color: 'red', fontWeight: 'bold' }}>Payment Mismatch</span>
                    : mapTransactionStatus(el),
                13: `${moment(el.CreatedOn).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.CreatedOn).format(AppConstant.commonStrings.HH_mm_dateFormat)}` || AppConstant.commonStrings.hypen,
                14: `${moment(el.UpdatedOn).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.UpdatedOn).format(AppConstant.commonStrings.HH_mm_dateFormat)}` || AppConstant.commonStrings.hypen,
                15: el.RelayStatus && el.RelayStatus.toUpperCase() === "SUCCESS" ? `${moment(el.UpdatedOn).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.UpdatedOn).format(AppConstant.commonStrings.HH_mm_dateFormat)}` : AppConstant.commonStrings.hypen,
                16: actionsButton(el, index)
            }
        })
    }

    /**
     * Method is used to handle pay click
     */
    const onPayClick = (el) => {
        if (isPaid(el?.RelayStatus)) {
            showAlert(toast.TYPE.ERROR, "Payment already made.");
        } else {
            window.open(process.env.REACT_APP_FSPAYMENTURL, '_blank', 'noopener,noreferrer')

        }
    }

    const manualPaymentHandler = (data) => {
        if (isPaid(data?.RelayStatus)) {
            showAlert(toast.TYPE.ERROR, "Payment already made.");
            return
        }
        setShowPaymentModal(true)
        setEditPaymentData({ ...editPaymentData, po: data.PONumber, amount: `$${getManualAmount(data, false, null)}`, serviceFee: `$${calculateServiceFee(data, eclipseServiceFee)}`, billAmount: `$${parseFloat(getTheNumberWithoutSpaces(data.CCCollect)).toFixed(2)}` })
        setParticularFieldValue({ ...particularFieldValue, po: data.PONumber, amount: `$${getManualAmount(data, false, null)}`, serviceFee: `$${calculateServiceFee(data, eclipseServiceFee)}`, billAmount: `$${parseFloat(getTheNumberWithoutSpaces(data.CCCollect)).toFixed(2)}` })
        setSelectedObj(data)
    }


    /**
* Function to render delete po confirmation popup
* @returns 
*/
    const deletePoConfirmationPopup = () => {
        const popupObj = {
            id: 'deletePoConfirmationPopup1',
            modalLabel: 'deletePoConfirmationPopup1',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: "Delete PO",
            bodyText: AppConstant.commonStrings.areYouSure + ' Delete PO ?',
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.no
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => { deletePoHandler(text) }} closepopup={closeDeletePoPopup} themeSelected={themeSelected} showModal={showDeletePoModal} />
    }

    const closeDeletePoPopup = () => {
        setShowDeletePoModal(false)
        setSelectedObj(null)
    }

    const deletePoHandler = (text) => {
        if (text === AppConstant.commonStrings.yes) {
            SetCurrentIndex(selectedObj?.RecID)
            deleteEclipseOpsPayloadLoadByRecID(selectedObj?.RecID)
            closeDeletePoPopup()
        } else {
            closeDeletePoPopup()
        }
    }



    const smsDueConfirmationPopup = () => {
        const popupObj = {
            id: 'smsDueConfirmationPopup1',
            modalLabel: 'smsDueConfirmationPopup1',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: "Send Payment Due SMS",
            bodyText: `${AppConstant.commonStrings.areYouSure} send payment due sms to ${selectedObj?.Field36} ?`,
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.no
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => { smsDueHandler(text) }} closepopup={closeSmsDuePopup} themeSelected={themeSelected} showModal={showSmsDueModal} />
    }

    const closeSmsDuePopup = () => {
        setShowSmsDueModal(false)
        setSelectedObj(null)
    }

    const smsDueHandler = (text) => {
        if (text === AppConstant.commonStrings.yes) {
            SetCurrentIndex(selectedObj?.RecID)
            SendDueSMS(selectedObj?.PONumber, selectedObj?.Field36)
            closeSmsDuePopup()
        } else {
            closeSmsDuePopup()
        }
    }


    const SendDueSMS = (poNumber, phoneNo) => {
        const payload = {
            "phoneNumber": phoneNo.replaceAll("-", ""),
            "messageType": "PAYMENTDUE",
            "poNumber": poNumber,
            "userName": userAccountDetails.UserName || ""

        }

        dispatch({ type: sagaActions.SEND_FSPAY_DUE_SMS, payload: payload })
    }

    /**
     * Function to render action buttons
     * @param {*} data 
     * @returns 
     */
    const actionsButton = (data, index) => {
        let disabled = false;
        if ((data.transactionStatus === 'PAYMENT_METHOD_UPDATED' && _.upperCase(data.Field31) !== 'FSPAY') || data.transactionStatus === 'PO_DELETED') {
            disabled = true;
        }
        return (
            <div className='d-flex gap-1 justify-content-between'>
                {uploadPermission && <span className={'pointer-cursor'} title='Upload Documents' onClick={() => {
                       
                    setFileUploadModal(true);
                    setSelectedObj(data)
                        
                }}>
                    {
                        <i className="fa-solid fa-paperclip fa-lg"></i>
                    }
                </span>}
                {
                    webPayPermission && <span className={disabled ? 'disabled' : 'pointer-cursor'} title='Pay' onClick={() => {
                        if (!disabled) {
                            onPayClick(data)
                        }
                    }}>
                        {
                            <img src={pay} alt='pay' className='actionImg' />
                        }
                    </span>
                }


                {receiptPermission &&
                    <span className={disabled ? 'disabled' : 'pointer-cursor'} title='Receipt' onClick={() => {
                        if (!disabled) {
                            viewAction(data)
                        }
                    }
                    }>
                        {
                            <img src={view} alt='view' className='actionImg' />
                        }
                    </span>
                }
                {
                    smsPermission && (data.RelayStatus?.toUpperCase() === "CREATED" || !data.RelayStatus) &&
                    <span className={disabled ? 'disabled' : 'pointer-cursor'}
                        title='SMS'
                        onClick={() => {
                            if (!disabled) {
                                setShowSmsDueModal(true);
                                setSelectedObj(data)
                                // SendDueSMS(data.Field36)
                            }
                        }}>
                        {
                            // <img src={email_appts_dark} alt='view' className='actionImg' />
                            <i className="fa-solid fa-message"></i>
                        }
                    </span>
                }
                {
                    emailPermission &&
                    <span className={disabled ? 'disabled' : 'pointer-cursor'}
                        title='Email'
                        onClick={() => {
                            if (!disabled) {
                                //No Receipt availble to send email
                                if (data.receiptUrl) {
                                    setShowShareReceiptModal(true);
                                    setSelectedObj(data);
                                } else {
                                    showAlert(toast.TYPE.INFO, "No receipt available to email.");
                                }
                            }
                        }}>
                        {
                            <img src={email_appts_dark} alt='view' className='actionImg' />
                        }
                    </span>
                }
                {
                    manualPaymentPermission &&
                    <span className={disabled ? 'disabled' : 'pointer-cursor'}
                        onClick={() => {
                            if (!disabled) {

                                manualPaymentHandler(data)
                            }
                        }}
                        title='Manual Payment'
                    >
                        {
                            <img src={info} alt='info' className='actionImg' />
                        }
                    </span>
                }
                {deletePermission && (data.RelayStatus?.toUpperCase() === "CREATED" || !data.RelayStatus) &&
                    <CustomButtonSS
                        disabled={(data.RelayStatus?.toUpperCase() === "CREATED" || !data.RelayStatus) && data.transactionStatus !== 'PO_DELETED' ? false : true}
                        isLoading={currentIndex !== "NA" && currentIndex === data.RecID ? true : false}
                        className={`no-border no-bg ${(data.RelayStatus?.toUpperCase() === "CREATED" || !data.RelayStatus) && data.transactionStatus !== 'PO_DELETED' ? "" : "disabled"}`}
                        onClick={() => { 
                            setSelectedObj(data)
                            setShowDeletePoModal(true)
                        }}
                        isIcon={true}
                        iconClass={"fa-regular fa-trash-can fa-lg color-red"}
                    />
                }
            </div>
        )
    }

    /**
     * Function to handle view button
     */
    const viewAction = (data) => {
        setSelectedObj(data)
        setShowModal(true)
    }

    /**
     * Format the amount and return the amount
     * @param {*} data 
     * @returns 
     */
    const getAmount = (data) => {
        const ccCollect = getTheNumberWithoutSpaces(data.CCCollect);
        const reStack = getTheNumberWithoutSpaces(data.ReStack);
        const sumAnount = parseFloat(ccCollect) + parseFloat(reStack) + parseFloat(data.serviceFee || 0);
        return (
            `$${sumAnount.toFixed(2)}`
        );
    };

    const calculateServiceFee = (data, eclipseServiceFeeData) => {
        const ccCollect = getTheNumberWithoutSpaces(data.CCCollect);
        const reStack = getTheNumberWithoutSpaces(data.ReStack);
        const sumAnount = parseFloat(ccCollect) + parseFloat(reStack);
        const eclipseFee = parseFloat(eclipseServiceFeeData?.Fee)
        if (eclipseServiceFeeData && eclipseServiceFeeData.FeeType === "CCARD") {
            return (sumAnount * eclipseFee).toFixed(2)
        }
        return eclipseFee.toFixed(2)
    }

    const getManualAmount = (data, serviceFee, eclipseServiceFeeData) => {
        const ccCollect = getTheNumberWithoutSpaces(data.CCCollect);
        const reStack = getTheNumberWithoutSpaces(data.ReStack);
        const sumAnount = parseFloat(ccCollect) + parseFloat(reStack);
        const eclipseFee = parseFloat(eclipseServiceFeeData?.Fee)
        if (!serviceFee) {
            return sumAnount.toFixed(2)
        }
        if (eclipseServiceFeeData && eclipseServiceFeeData.FeeType === "CCARD") {
            return (sumAnount + (sumAnount * eclipseFee)).toFixed(2)
        }
        return (sumAnount + eclipseFee).toFixed(2)
    }

    /**
    * Format the amount and return the paid amount
    * @param {*} data 
    * @returns 
    */
    const getPaidAmount = (data) => {
        if (data.RelayStatus === 'Success') {
            // If totalPaid is explicitly set (actual amount received), use it to detect mismatches
            if (data.totalPaid !== undefined && data.totalPaid !== null) {
                return `$${parseFloat(data.totalPaid).toFixed(2)}`;
            }
            const ccCollect = getTheNumberWithoutSpaces(data.CCCollect);
            const reStack = getTheNumberWithoutSpaces(data.ReStack);
            const sumAnount = parseFloat(ccCollect) + parseFloat(reStack) + parseFloat(data.serviceFee || 0)
            return (
                `$${sumAnount.toFixed(2)}`
            );
        } else if (data.RelayStatus === 'Partial Payment') {
            const ccCollect = data?.totalPaid;
            const ccCollectFin = parseFloat(ccCollect);
            return (
                `$${ccCollectFin.toFixed(2)}`
            );
        }
        return '$0'
    };

    /**
     * function used to remove spaces in the number
     * @param {*} number
     * @returns
     */
    const getTheNumberWithoutSpaces = (number) => {
        if (number === null || number === undefined) return "0";
        return String(number).replace(/\s/g, "");
    };

    /**
     * Helper to format the mobile number
     * @param {*} number 
     * @returns 
     */
    const formatPhoneNumber = (number) => {
        if (number === null || number === undefined) return '-';

        // Use a regular expression to match the parts of the phone number
        let match = String(number).match(/(\d{3})-(\d{3})-(\d{4})/);

        // If the input matches the expected format
        if (match) {
            // Return the formatted phone number
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        } else {
            return number
        }
    }

    /**
     * This function is used to get the data and validate
     * @returns 
     */
    const getBodyData = () => {
        if (eclipseOpsPayLoadArr && eclipseOpsPayLoadArr.length) {
            return formatListDataDrillDown(eclipseOpsPayLoadArr)
        }
        else {
            return []
        }
    }


    /**
     * Function to return max end date
     */
    const getMaxEndDate = (startDate) => {
        let currentDate = new Date();
        let threeMonthslater = new Date(startDate);
        threeMonthslater.setMonth(startDate.getMonth() + 3);
        threeMonthslater.setDate(threeMonthslater.getDate() - 1)
        if (currentDate <= threeMonthslater) {
            setMaxEndDate(currentDate)
            extraDataToShow.filter.dateRange.EndDate.value = moment(currentDate).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)
        } else {
            setMaxEndDate(threeMonthslater)
            extraDataToShow.filter.dateRange.EndDate.value = moment(threeMonthslater).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)
        }
    }

    /**
     * Function to handle startdate change
     * @param {*} date 
     */
    const handleStartDate = (date) => {
        let threeMonthslater = new Date(date);
        threeMonthslater.setMonth(date.getMonth() + 3);
        if (threeMonthslater < selectedEndDate) {
            setSelectedEndDate(null)
        }
        setSelectedStartDate(date)
        extraDataToShow.filter.dateRange.StartDate.value = moment(date).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)
        getMaxEndDate(date)
       
    }

    const toggleModal = () => {
        setFSPayPOHistoryModal(!fSPayPOHistoryModal);
    }


    const showCustomDropDownForFilters = () => {
        const filterDataArr = [
            {
                name: 'All',
                value: "ALL"
            },
            {
                name: 'Pending',
                value: 'CREATED'
            },
            {
                name: 'Success',
                value: 'Success'
            },
            // {
            //     name: 'Po Deleted',
            //     value: 'PO_DELETED'
            // }
        
        ]
        return (
            <div className='d-flex align-items-center'>
                <CustomDropDown themeSelected={themeSelected} data={filterDataArr} placeHolder={currentFilterSelected?.name || "All"} onSelect={(event) => {
                    setCurrentFilterSelected(event)
                    extraDataToShow.filter.currentFilterSelected.value = currentFilterSelected?.name;
                }} keyStr={'name'}
                    title={"Filter by status"} customClass={"min-width-12"} key={currentFilterSelected?.value}
                />
            </div>
        )
    }

    const showWarehouseDropDown = () => {
        const warehouseListWithAll = [{ WarehouseName: 'All Warehouses', ID: 'all' }, ...(userWarehouseList || [])]
        const onSelect = (warehouse) => {
            if (warehouse.ID === 'all') {
                setDropdownWarehouse(null)
            } else {
                setDropdownWarehouse(warehouse)
            }
        }
        return (
            <div className='d-flex align-items-center'>
                <CustomDropDown themeSelected={themeSelected} data={warehouseListWithAll} placeHolder={dropdownWarehouse?.WarehouseName || "All Warehouses"} onSelect={onSelect} keyStr={'WarehouseName'}
                    title={""} customClass={"min-width-12"} key={dropdownWarehouse?.ID}
                />
            </div>
        )
    }

    function searchAndFilter(data, searchTerm = "", filters = {}, searchKeys = []) {
        const lowerSearch = searchTerm.toUpperCase();

        return data.filter(item => {
            // Apply search filter only if searchTerm exists
            const matchesSearch =
                !searchTerm ||
                searchKeys.some(key => {
                    let value = String(item[key] ?? "").toUpperCase();

                    // Remove hyphens only for Field36
                    if (key === "Field36") {
                        value = value.replace(/-/g, "");
                    }
        

                    // Also remove hyphens from search term when searching Field36
                    const termToCompare =
                        key === "Field36"
                            ? lowerSearch.replace(/-/g, "")
                            : lowerSearch;

                    return value.includes(termToCompare);
                });

            // Apply filters only if filter value is not "ALL"
            const matchesFilters = Object.entries(filters).every(([key, value]) => {
                if (value === "" || value === null || value === undefined || value === "ALL") return true;

                let itemValue = item[key];

                if (key === "RelayStatus" && (itemValue === null || itemValue === undefined)) {
                    itemValue = "CREATED";
                }

                return String(itemValue).toUpperCase() === String(value).toUpperCase();
            });

            return matchesSearch && matchesFilters;
        });
    }


    const fileUploadPopup = () => {
        const popupObj = {
            id: 'fileUploadPopup1',
            modalLabel: 'fileUploadPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'lg',
            title: "File Upload",
            bodyText: ShowFileUploadForm(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.submit
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={() => { closeFileUpload() }} themeSelected={themeSelected} showModal={fileUploadModal} />
    }

    const closeFileUpload = () => {
        setFileUploadModal(false);
        setSelectedObj(null)
    }

    const ShowFileUploadForm = () => {
        return (
            <>
                <EclipseOpsPaymentFileUpload onSubmit={(fileUrl) => updateFileUrlForEclipseOps(fileUrl)} removeFile={(fileUrl) => removeFileUrlForEclipseOps(fileUrl)} exsistingFile={selectedObj?.fileUrl || ""} themeSelected={themeSelected} />
            </>
        )
    }


    const updateFileUrlForEclipseOps = (fileUrl) => {
        if (selectedObj && selectedObj.RecID) {
            SetCurrentIndex(selectedObj.RecID)
            setTimeout(() => {
      
                const params = {
                    "recID": selectedObj?.RecID || "",
                    "CRUDTYPE": "FU",
                    "fileUrl": fileUrl
                }
      
                dispatch({ type: sagaActions.GET_ECLIPSE_OPS_PAYMENT_LOAD_DETAILS, payload: params });
            }, 0)
        }
    }


    const removeFileUrlForEclipseOps = (fileUrl) => {
        if (selectedObj && selectedObj.RecID) {
            SetCurrentIndex(selectedObj.RecID)
            setTimeout(() => {
      
                const params = {
                    "recID": selectedObj?.RecID || "",
                    "CRUDTYPE": "RF",
                    "fileUrl": fileUrl
                }
      
                dispatch({ type: sagaActions.GET_ECLIPSE_OPS_PAYMENT_LOAD_DETAILS, payload: params });
            }, 0)
        }
    }



    return (
        <div className=''>
            <div className='d-flex justify-content-between align-items-center my-2 mx-3'>
                <div className='fw-bold'>{AppConstant.fsWarehouse.eclipseOpsHeader}</div>
                <div className='d-flex justify-content-end align-items-end gap-2'>
                   
                    {(
                        <div className='d-flex appt-report-header gap-3 align-items-center'>
                            <div className="pos-rel">
                                <div className='d-flex flex-column align-items-start'>
                                    <label className='boldText m-0 f-14'><i className="fa-regular fa-calendar"></i> Start Date </label>
                                    <button
                                        className={'datePickerBtn h-100 w-100'}
                                        onClick={() => setShowStartDate(!showStartDate)}
                                        disabled={isLoading}
                                    >
                                        <span className="btn-title">{selectedStartDate ?
                                            formatDate_MM_DD_YYYY(selectedStartDate) : 'Start Date'}</span>
                                        <i
                                            className="fa-regular fa-calendar"
                                            style={{ marginInline: "9px" }}
                                        ></i>

                                    </button>
                                    {
                                        showStartDate && <div className="appt-summary-ss-datePicker" >
                                            <DatePickerSS maxDate={new Date()} setSelectedDate={handleStartDate} selectedDate={selectedStartDate} closeCalendar={() => { setShowStartDate(!showStartDate) }} />
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="pos-rel">
                                <div className='d-flex flex-column align-items-start'>
                                    <label className='boldText m-0 f-14'><i className="fa-regular fa-calendar"></i> End Date </label>

                                    <button
                                        className={'datePickerBtn h-100 w-100'}
                                        onClick={() => setShowEndDate(!showEndDate)}
                                        disabled={isLoading}
                                    >
                                        <span className="btn-title">{selectedEndDate ?
                                            formatDate_MM_DD_YYYY(selectedEndDate) : 'End Date'}</span>
                                        <i
                                            className="fa-regular fa-calendar"
                                            style={{ marginInline: "9px" }}
                                        ></i>

                                    </button>
                                    {
                                        showEndDate && <div className="appt-summary-ss-datePicker">
                                            <DatePickerSS setSelectedDate={setSelectedEndDate} minDate={new Date(selectedStartDate)} maxDate={maxEndDate} selectedDate={selectedEndDate} closeCalendar={() => { setShowEndDate(!showEndDate) }} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                    {!searchStr && showCustomDropDownForFilters()}
                    {/* {userType !== 'USER' && showWarehouseDropDown()} */}
                    {warehouseFilterPermission && showWarehouseDropDown()}
                    <div className='w-25 eclipse-ops-search-wrapper' style={{ minWidth: "260px" }}>
                        <WarehouseSearch
                            placeholder="Search"
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)} />
                    </div>

                    <div className='d-flex align-items-center'>
                        <button
                            className='datePickerBtn'
                            onClick={() => {
                                setDownloadStartDate(selectedStartDate)
                                setDownloadEndDate(selectedEndDate)
                                setDownloadEmail(userAccountDetails?.Email || userAccountDetails?.UserName || '')
                                // Pre-fill warehouse: prefer dropdownWarehouse, then fall back to selectedWarehouse
                                if (dropdownWarehouse) {
                                    setDownloadWarehouse(dropdownWarehouse)
                                } else if (selectedWarehouse?.warehouseName) {
                                    const match = (userWarehouseList || []).find(w => w.WarehouseName === selectedWarehouse.warehouseName)
                                    setDownloadWarehouse(match || null)
                                } else {
                                    setDownloadWarehouse(null)
                                }
                                setShowDownloadModal(true)
                            }}
                            title="Download Report"
                        >
                            <i className="fa-solid fa-download" style={{ marginInline: "6px" }}></i>
                            <span className="btn-title">Download</span>
                        </button>
                    </div>

                </div>
            </div>
            <div className='eclipseOpsListContainer' style={{ maxHeight: userType === "SUPERADMIN" ? "55vh" : "65vh" }} ref={divRef} onScroll={(e) => handelInfiniteScroll(e)}>
                <DrilldownTableSS
                    key={Math.random()}
                    themeSelected={themeSelected}
                    bodyData={getBodyData()}
                    titleData={titleDD}
                    showCollapse={false}
                    showInput={false}
                    showSort={false}
                    hasCollapsableContent={false}
                    collapsableData={[]}
                    accordionPrimaryIndex={1}
                    drillDownReport={eclipseOpsPayLoadArr?.data?.Items}
                    initiateDrillDownReport={currentPage === 1 && isLoading ? true : false}
                    loaderArray={17}
                    sortingAction={sagaActions.SORT_SS_USER_TABLE}
                    subRoot={{ pathName: 'eclipseOpsPaymentLoadObj' }}
                    showUTCTime={true}
                />
            </div>
            {isLoading ? <div className='d-flex justify-content-center w-100'>
                <TinyLoader />
            </div> : ""
            }
            {showReceiptPopup()}
            {showReceiptSharePopup()}
            {showPaymentPopup()}
            {deletePoConfirmationPopup()}
            {fileUploadPopup()}
            {smsDueConfirmationPopup()}
            {showDownloadRequestPopup()}
            {fSPayPOHistoryModal &&
                <ModalSS toggleModal={toggleModal}>
                    <FSPayPOHistory
                        themeSelected={themeSelected}
                        data={poData}
                    />
                </ModalSS>

            }
        </div>
    )
}

export default EclipseOpsPaymentLoad